import { Controller } from "@hotwired/stimulus";

// Single-select toggle boxes for the LtS tier on the settings (enroll/edit)
// forms. The radio inputs enforce single selection natively; this controller
// only toggles the selected visual state on the boxes.
export default class extends Controller {
  connect() {
    this.markSelected();
  }

  select() {
    this.markSelected();
  }

  markSelected() {
    this.element.querySelectorAll(".lts-tier-box").forEach((box) => {
      const input = box.querySelector(".lts-tier-radio");
      box.classList.toggle("lts-tier-box-selected", !!(input && input.checked));
    });
  }
}
